import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { vnApp_leadpilot } from "../vnApp_leadpilot";
import { html, LpButton, LpPageHeader } from "~/design-system";
const TWO_FACTOR_LABELS = {
    disabled: "Disabled",
    email: "Enabled via Email",
};
export class usersProfile_template extends vnTemplate {
    /**
     * @inheritDoc
     */
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "User Profile",
            description: "Manage your general account information.",
            icon: "user",
            actions: html `
                    ${LpButton({
                label: "Back",
                prefixIcon: "arrow-left",
                size: "base",
                variant: "secondary",
                attributes: {
                    "data-bind": "visible: hasUserOthersAccess, click: onClickBack",
                },
            })}
                    ${LpButton({
                label: "Edit",
                prefixIcon: "pencil-simple",
                size: "base",
                variant: "primary",
                attributes: {
                    "data-bind": "visible: hasUpdateAccess, click: onClickEdit",
                },
            })}
                `,
        })}

            <div class="profile-page__intro">
            <div class="content-column"> 
                <p class="profile-page__description">Manage your general account information</p>

                </div>
            </div>

            <div class="profile-page">
               

                <section class="profile-card">
                    <header class="profile-card__header">
                        <h2 class="profile-card__title">Profile Picture</h2>
                    </header>
                    <div class="profile-card__body">
                        <div class="profile-summary">
                            <div class="profile-summary__avatar">
                                <img class="profile-summary__image" data-bind="attr:{ src: pictureUrl, alt: fullName }" alt="">
                            </div>
                            <div class="profile-summary__details">
                                <p class="profile-summary__name" data-bind="text: fullName"></p>
                                <p class="profile-summary__meta" data-bind="text: email"></p>
                                <p class="profile-summary__meta" data-bind="text: loginName"></p>
                                <ul class="profile-summary__properties" data-bind="foreach: userProperties">
                                    <li class="profile-summary__property" data-bind="css: logoImageUrl"></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="profile-columns">
                    <section class="profile-card profile-card--column">
                        <header class="profile-card__header">
                            <h2 class="profile-card__title">Personal Information &amp; Roles</h2>
                        </header>
                        <div class="profile-card__body profile-stack">
                            <div class="profile-field-grid">
                                <div class="profile-field">
                                    <span class="profile-field__label">First Name</span>
                                    <span class="profile-field__value" data-bind="text: firstName"></span>
                                </div>
                                <div class="profile-field">
                                    <span class="profile-field__label">Last Name</span>
                                    <span class="profile-field__value" data-bind="text: lastName"></span>
                                </div>
                            </div>

                            <div class="profile-field-grid">
                                <div class="profile-field">
                                    <span class="profile-field__label">User Name</span>
                                    <span class="profile-field__value" data-bind="text: loginName"></span>
                                </div>
                                <div class="profile-field">
                                    <span class="profile-field__label">Email</span>
                                    <span class="profile-field__value" data-bind="text: email"></span>
                                </div>
                            </div>

                            <div class="profile-field">
                                <span class="profile-field__label">Role(s)</span>
                                <span class="profile-field__value" data-bind="text: rolesDisplay"></span>
                            </div>
                        </div>
                    </section>

                    <section class="profile-card profile-card--column">
                        <header class="profile-card__header">
                            <h2 class="profile-card__title">Password</h2>
                        </header>
                        <div class="profile-card__body profile-stack">
                            <div class="profile-field">
                                <span class="profile-field__label">Password</span>
                                <span class="profile-field__value">••••••••</span>
                            </div>

                            <div class="profile-field">
                                <span class="profile-field__label">Two-Factor Authentication</span>
                                <span class="profile-field__value" data-bind="text: twoFactorDisplay"></span>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            `;
    }
    /**
     * @inheritDoc
     */
    getTemplateName() {
        return "usersProfile-template";
    }
    /**
     * @inheritDoc
     */
    getMainElementType() {
        return "div";
    }
    /**
     * @inheritDoc
     */
    getMainElementClasses() {
        return [""];
    }
    /**
     * @inheritDoc
     */
    buildViewModel() {
        let huit_neuf_this = this;
        const viewModel = {
            idUser: ko.observable(""),
            firstName: ko.observable(""),
            lastName: ko.observable(""),
            loginName: ko.observable(""),
            hasUpdateAccess: ko.observable(false),
            hasUserOthersAccess: ko.observable(this.caller.hasAccessToSection(vnApp_leadpilot.SECTION_ID_USER_OTHERS)),
            email: ko.observable(""),
            pictureUrl: ko.observable(null),
            roles: ko.observableArray([]),
            userProperties: ko.observableArray([]),
            isActive: ko.observable(""),
            twoFactorMethod: ko.observable("email"),
            fullName: ko.pureComputed(function () {
                const firstName = viewModel.firstName();
                const lastName = viewModel.lastName();
                return [firstName, lastName].filter(Boolean).join(" ");
            }),
            rolesDisplay: ko.pureComputed(function () {
                const roles = viewModel.roles();
                return roles.length ? roles.join(", ") : "—";
            }),
            twoFactorDisplay: ko.pureComputed(function () {
                const method = viewModel.twoFactorMethod();
                return TWO_FACTOR_LABELS[method] || method || "—";
            }),
            onClickEdit: function (data, event) { huit_neuf_this.onClickEdit(data.idUser()); },
            onClickBack: function () { page("/users/"); },
        };
        return viewModel;
    }
    /**
     * Sets has update access.
     *
     * @param hasUpdateAccess
     */
    setHasUpdateAccess(hasUpdateAccess) {
        this.getTemplateViewModel().hasUpdateAccess(hasUpdateAccess);
    }
    /**
     * Sets the roles.
     *
     * @param selectedRoles
     */
    setRoles(selectedRoles) {
        let roles = [];
        for (let r of selectedRoles) {
            roles.push(r.name);
        }
        this.getTemplateViewModel().roles(roles);
    }
    /**
     * Sets the properties.
     *
     * @param properties
     */
    setProperties(properties) {
        this.getTemplateViewModel().userProperties(properties);
    }
    /**
     * Handles on edit button click event.
     *
     * @param idUser
     */
    onClickEdit(idUser) {
        this.caller.editUser(idUser);
    }
}
